import { Step } from "../types";

export const STEPS: Step[] = [
  { key: 'step-1', label: 'Treatment Type', path: '/bookonline/step-1' },
  { key: 'step-2', label: 'Patient Type', path: '/bookonline/step-2' },
  { key: 'step-3', label: 'Time Slots', path: '/bookonline/step-3' },
  { key: 'step-4', label: 'Patient Details', path: '/bookonline/step-4' },
  { key: 'confirmation', label: 'Confirmation', path: '/bookonline/confirmation' },
];

export const SMALL_SCREEN_DAYS_TO_SHOW = 3;
export const LARGE_SCREEN_DAYS_TO_SHOW = 7;
export const TIME_SLOT_INCREMENT_MINUTES = 30;
export const MIN_SLOTS_THRESHOLD = 5;
export const EXTENDED_SLOTS_DAYS = 30;

